import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoneNumberPad = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.4983 3.5C11.4123 3.5 10.5283 4.384 10.5283 5.47C10.5283 6.556 11.4123 7.439 12.4983 7.439C13.5853 7.439 14.4693 6.556 14.4693 5.47C14.4693 4.384 13.5853 3.5 12.4983 3.5Z",
			fill: "#000000"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.4983 10.0303C11.4123 10.0303 10.5283 10.9143 10.5283 12.0003C10.5283 13.0863 11.4123 13.9693 12.4983 13.9693C13.5853 13.9693 14.4693 13.0863 14.4693 12.0003C14.4693 10.9143 13.5853 10.0303 12.4983 10.0303Z",
			fill: "#000000"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.4983 16.5605C11.4123 16.5605 10.5283 17.4445 10.5283 18.5305C10.5283 19.6165 11.4123 20.4995 12.4983 20.4995C13.5853 20.4995 14.4693 19.6165 14.4693 18.5305C14.4693 17.4445 13.5853 16.5605 12.4983 16.5605Z",
			fill: "#000000"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.21902 3.5C5.13302 3.5 4.24902 4.384 4.24902 5.47C4.24902 6.556 5.13302 7.439 6.21902 7.439C7.30602 7.439 8.19002 6.556 8.19002 5.47C8.19002 4.384 7.30602 3.5 6.21902 3.5Z",
			fill: "#000000"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.21902 10.0303C5.13302 10.0303 4.24902 10.9143 4.24902 12.0003C4.24902 13.0863 5.13302 13.9693 6.21902 13.9693C7.30602 13.9693 8.19002 13.0863 8.19002 12.0003C8.19002 10.9143 7.30602 10.0303 6.21902 10.0303Z",
			fill: "#000000"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.7795 7.43949C19.8665 7.43949 20.7505 6.55549 20.7505 5.46949C20.7505 4.38349 19.8665 3.50049 18.7795 3.50049C17.6935 3.50049 16.8095 4.38349 16.8095 5.46949C16.8095 6.55549 17.6935 7.43949 18.7795 7.43949Z",
			fill: "#000000"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.7795 10.0303C17.6935 10.0303 16.8095 10.9143 16.8095 12.0003C16.8095 13.0863 17.6935 13.9693 18.7795 13.9693C19.8665 13.9693 20.7505 13.0863 20.7505 12.0003C20.7505 10.9143 19.8665 10.0303 18.7795 10.0303Z",
			fill: "#000000"
		})
	]
});
export default SvgPhoneNumberPad;
